export default "__VITE_ASSET__DQA4pyJX__"